export const COUPON_HISTORY_SLICE_NAME = 'gygCouponHistory'

export const GET_COUPON_HISTORY_BY_USER_ID_ACTION = `${COUPON_HISTORY_SLICE_NAME}/getCouponHistoryByUserId`
